import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openConfirmation } from 'helpers/Confirmation';
import { BoolToString } from 'components';
import { openSnackbar } from 'helpers/Notifier';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { httpStatusEnum, TE } from 'appconstants';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { ProtocolIdSelector } from 'selectors';
import { bindLogger } from 'helpers/BindLogger';

import EditOPENIRTFProviderSetup from './EditOPENIRTFProviderSetup';
import OpenItrfProviderForm from './OpenItrfProviderForm';


const columns = [
  {
    name: 'credentialDescription',
    type: 'string',
    label: 'Credential Description',
    filterable: true
  },
  {
    name: 'code',
    type: 'string',
    label: 'Credential Type',
    filterable: true
  },
  {
    name: 'isRequiredYn',
    type: 'string',
    label: 'Required?',
    align: 'center',
    filterable: true,
    renderCell: data => <BoolToString boolValue={data.isRequiredYn} />
  },
  {
    name: 'esysStatus',
    type: 'object',
    label: 'Status',
    filterable: true,
    optionList: [
      { label: 'ACTIVE', value: 'ACTIVE' },
      { label: 'INACTIVE', value: 'INACTIVE' }
    ]
  },
  {
    name: 'credRequired',
    type: 'string',
    label: 'From Credentials',
    align: 'center',
    filterable: true,
    renderCell: data => <BoolToString boolValue={data.credRequired} />
  }
];

let setEditingFlag;
const OPENITRFProvidesetup = ({
  data,
  prlId,
  state,
  setState,
  saveIRTFInfo,
  psrs,
  permission,
  selectedLogistics
}) => {

  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingFlag = (flg) => {
      setEditing(flg);
      setState({});
    };
    return (
      <EditOPENIRTFProviderSetup
        state={state || row}
        setEditing={setEditing}
        defaultRow={row}
        setState={setState}
        psrs={psrs}
      />
    );
  };

  const saveIRTF = () => {
    const { id, isRequiredYn } = state;
    saveIRTFInfo({
      ...state,
      isRequiredYn: isRequiredYn === undefined ? true : isRequiredYn,
      prlId,
      prsId: id
    });
  };


  return (
    <div className='mt-3'>
      <OpenItrfProviderForm data={selectedLogistics || {}} />
      <div className='mt-3'>
        <ValidatorForm onSubmit={saveIRTF}>
          <GridTable
            tag={`${TE.ID}openirtfprovidersetup${TE.TABLE}`}
            exportTitle={`OPEN IRTF Provider Setup-${useGetPathProtocol()}-OPEN Setup`}
            columns={columns}
            user={GetUserFullName()}
            rows={data}
            editable
            // deletable
            filterable
            sortable
            editMode={permission}
            allowAddRow
            enableToolbar
            renderEditRow={RenderEditRow}
            rowEditable={() => true}
            rowDeletable={() => true}
            toPdf={false}
          />
        </ValidatorForm>
      </div>
    </div>

  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    protocolId: ProtocolIdSelector(state)
  }),
  dispatch => bindActionCreators(
    {},
    dispatch
  )
);


const OPENITRFProvideSetup = compose(
  withAppContext,
  withConnectState,
  withState('state', 'setState', {}),
  withHandlers({
    saveIRTFInfo: props => postBody => {
      const {
        onSave,
        setState,
        context,
        protocolId
      } = props;
      const confirmSave = () => {
        const {
          code, credentialDescription, prlId, prsId, isRequiredYn, esysStatus, credRequired
        } = postBody;
        const status = esysStatus || 'ACTIVE';
        const payload = {
          code, credentialDescription, isRequiredYn, prlId, prtId: protocolId, prsId, esysStatus: status, credRequired
        };
        bindLogger(onSave, context)(protocolId, payload).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            openSnackbar({
              message: GetFromCtxValue(context, 'PROTOCOL_OPENITRFSETUP_SUCCESS'),
              variant: 'success',
              name: 'open_irtf'
            });
            setState({});
            setEditingFlag(false);
          }
        });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'PROTOCOL_OPENITRFSETUP_CONFIRM'),
        onAction: confirmSave,
        name: 'open_irtf'
      });
    }
  })
)(OPENITRFProvidesetup);


export default OPENITRFProvideSetup;
